import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  listContainer: {
    background: 'rgba(202, 202, 252, 0.15)',
    borderRadius: '3px',
    padding: '5px',
  },
  list: {
    margin: '5px 30px',
  },
  listItem: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    textAlign: 'left',
    padding: '8px',
  }
}));